module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/13.8b013070.jpg";